/* KiNDKiT Foundation JS - vanilla, no dependencies. Scroll-reveal + sticky header behaviour. */
(function () {
  'use strict';

  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('kk-in-view');
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.kk-reveal').forEach(function (el) {
        revealObserver.observe(el);
      });
    });
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.kk-reveal').forEach(function (el) {
        el.classList.add('kk-in-view');
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    var header = document.querySelector('[data-kk-header]');
    if (!header) return;

    var toggleScrolledState = function () {
      if (window.scrollY > 8) {
        header.classList.add('kk-header--scrolled');
      } else {
        header.classList.remove('kk-header--scrolled');
      }
    };

    toggleScrolledState();
    window.addEventListener('scroll', toggleScrolledState, { passive: true });

    var triggers = header.querySelectorAll('[data-kk-menu-trigger]');
    var isDesktop = function () {
      return window.matchMedia('(min-width: 990px)').matches;
    };
    var hoverCloseTimer = null;

    var closeAllMenus = function () {
      triggers.forEach(function (t) {
        t.setAttribute('aria-expanded', 'false');
        var panelId = t.getAttribute('aria-controls');
        var panel = panelId ? document.getElementById(panelId) : null;
        if (panel) panel.classList.remove('kk-menu-panel--open');
      });
      header.classList.remove('kk-header--menu-open');
    };

    var positionPanel = function (trigger, panel) {
      var wrapper = trigger.closest('.kk-header__nav-item') || trigger;
      var headerRect = header.getBoundingClientRect();
      var wrapperRect = wrapper.getBoundingClientRect();
      var left = wrapperRect.left - headerRect.left;
      var panelWidth = panel.offsetWidth || 220;
      var maxLeft = header.clientWidth - panelWidth - 16;
      if (left > maxLeft) left = Math.max(maxLeft, 16);
      if (left < 0) left = 0;
      panel.style.left = left + 'px';
    };

    var openPanelFor = function (trigger) {
      var panelId = trigger.getAttribute('aria-controls');
      var panel = panelId ? document.getElementById(panelId) : null;
      closeAllMenus();
      if (panel) {
        positionPanel(trigger, panel);
        trigger.setAttribute('aria-expanded', 'true');
        panel.classList.add('kk-menu-panel--open');
        header.classList.add('kk-header--menu-open');
      }
    };

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        event.stopPropagation();
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';
        closeAllMenus();
        if (!isOpen) openPanelFor(trigger);
      });
    });

    document.addEventListener('click', closeAllMenus);
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeAllMenus();
    });

    var cancelCloseTimer = function () {
      if (hoverCloseTimer) {
        clearTimeout(hoverCloseTimer);
        hoverCloseTimer = null;
      }
    };

    var scheduleClose = function () {
      cancelCloseTimer();
      hoverCloseTimer = setTimeout(closeAllMenus, 300);
    };

    header.querySelectorAll('.kk-header__nav-item').forEach(function (item) {
      var trigger = item.querySelector('[data-kk-menu-trigger]');
      if (!trigger) return;

      item.addEventListener('mouseenter', function () {
        if (!isDesktop()) return;
        cancelCloseTimer();
        openPanelFor(trigger);
      });

      item.addEventListener('mouseleave', function () {
        if (!isDesktop()) return;
        scheduleClose();
      });
    });

    header.querySelectorAll('.kk-menu-panel').forEach(function (panel) {
      panel.addEventListener('click', function (event) {
        event.stopPropagation();
      });
      panel.addEventListener('mouseenter', function () {
        if (!isDesktop()) return;
        cancelCloseTimer();
      });
      panel.addEventListener('mouseleave', function () {
        if (!isDesktop()) return;
        scheduleClose();
      });
    });

    var mobileToggle = header.querySelector('[data-kk-mobile-toggle]');
    var mobileNav = header.querySelector('[data-kk-mobile-nav]');
    if (mobileToggle && mobileNav) {
      mobileToggle.addEventListener('click', function (event) {
        event.stopPropagation();
        var isOpen = mobileToggle.getAttribute('aria-expanded') === 'true';
        mobileToggle.setAttribute('aria-expanded', String(!isOpen));
        mobileNav.classList.toggle('kk-mobile-nav--open', !isOpen);
        document.body.classList.toggle('kk-no-scroll', !isOpen);
      });
    }
  });
})();
